import React, { useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import { useParams, useNavigate } from "react-router-dom";

function VerifyMobilePage() {
  const { payload } = useParams();
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleVerify = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_BASE_URL}/verify-mobile`, {
        payload,
        code,
      });

      if (res.data.success) {
        const userData = localStorage.getItem("user");
        setMessage("Mobile verified successfully! Redirecting...");
        setTimeout(() => navigate("/login"), 2500);
      } else {
        setError(res.data.message || "Verification failed.");
      }
      if (res.data.success) {
        setMessage("Mobile verified successfully!");

        // Check login status — adjust logic as per your auth setup
        const isLoggedIn =
          localStorage.getItem("user");

        if (!isLoggedIn) {
          setMessage("Mobile verified successfully! Redirecting to login...");
          setTimeout(() => navigate("/login"), 2500);
        } else {
          // Stay on page or optionally navigate to dashboard
          setTimeout(() => navigate("/companies"), 2000);
        }
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-5 col-12">
          <div className="inbx formbxx">
            <h2 className="mb-3 text-center fw700">
              <i className="bi bi-phone"></i> Mobile Verification
            </h2>
            {error && <div className="alert alert-danger">{error}</div>}
            {message && <div className="alert alert-info">{message}</div>}
            <form onSubmit={handleVerify}>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Enter 6-digit code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                maxLength="6"
                required
              />
              <button type="submit" className="btn btn-success w-100">
                Verify Number
              </button>
            </form>
          </div>
        </div>
        <div className="col-md-7 col-12 gx-0 limgcn">
          <img src="/log-bg.png" alt="Logo" className="login-bg" />
        </div>
      </div>
    </div>
  );
}

export default VerifyMobilePage;
